import { TextField } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

import HNSColors from "../../../../../ui library/HNSColors";
import { PAYMENTS_MODAL_STYLES } from "../../../../payments/styles/styles";

export default function SettlementPaymentsDateField({ fieldName, fieldValue, onChange }) {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        className="w-full"
        value={fieldValue}
        onChange={(newValue) => onChange(fieldName, newValue)}
        slotProps={{
          textField: { size: "small", sx: PAYMENTS_MODAL_STYLES.datePickerTextField },
          openPickerButton: { sx: { marginRight: "8px", color: HNSColors.primary[500] } },
        }}
        renderInput={(params) => <TextField {...params} />}
      />
    </LocalizationProvider>
  );
}

